import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './FoundingDateScreen.module.css';
import { TMobileSignupForm } from '../../form/form';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-684. Month / year the company was founded. Reads/writes the shared mobile
// signup form store (DIT-664).
export const FoundingDateScreen = () => {
  const { t } = useLingui();
  const { register, watch } = useFormContext<TMobileSignupForm>();

  const month = watch('startDateMonth');
  const year = watch('startDateYear');
  const isValid = /^\d{1,2}$/.test(month) && /^\d{4}$/.test(year);

  return (
    <StepLayout
      stageTitle={t`Business details`}
      heading={t`When was your company founded?`}
      subHeading={t`A rough estimate is fine.`}
      ctaDisabled={!isValid}
    >
      <div className={styles.row}>
        <Input
          {...register('startDateMonth')}
          label={t`Month`}
          placeholder={t`MM`}
          inputMode="numeric"
          maxLength={2}
        />
        <Input
          {...register('startDateYear')}
          label={t`Year`}
          placeholder={t`YYYY`}
          inputMode="numeric"
          maxLength={4}
        />
      </div>
    </StepLayout>
  );
};
